import { useCallback, useState } from 'react'
import styles from './ElementInfo.module.scss'
import { ScoopText } from '../../../ui'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import { updateElementTitle } from '../../../../store/actions'

export const ElementInfo = ({ title, type, id }) => {
    const dispatch = useDispatch()
    const activeMode = useSelector((state) => state.ui.activeMode)
    const [editTitle, setEditTitle] = useState(false)
    const [elementTitle, setElementTitle] = useState(title || '')
    const debounceFn = useCallback(
        debounce((value) => {
            dispatch(updateElementTitle(id, value))
        }, 200),
        []
    )

    return (
        <div className={`${styles.elementInfoContainer} ${editTitle ? styles.editing : ''}`}>
            {editTitle ? (
                <input
                    value={elementTitle}
                    onChange={(e) => {
                        setElementTitle(e.target.value)
                        debounceFn(e.target.value)
                    }}
                    className={styles.editElementTitleInput}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setEditTitle(false)
                        }
                    }}
                />
            ) : (
                <ScoopText
                    size="xs"
                    weight="semibold"
                    onDoubleClick={() => {
                        if (activeMode === 'edit') setEditTitle(true)
                    }}
                    className={styles.elementInfoText}
                >
                    {title + ' - ' + type}
                </ScoopText>
            )}
        </div>
    )
}
